import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn('Supabase env vars not configured, realtime features will be disabled')
}

export const supabase = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null

export async function setSupabaseSession(session) {
  if (!supabase || !session?.access_token) return

  try {
    if (session.refresh_token) {
      await supabase.auth.setSession({
        access_token: session.access_token,
        refresh_token: session.refresh_token,
      })
    }
    supabase.realtime.setAuth(session.access_token)
  } catch (err) {
    console.warn('[Supabase] Failed to wire auth session for Realtime:', err)
  }
}

if (supabase) {
  try {
    const storedAccessToken = localStorage.getItem('access_token')
    if (storedAccessToken) {
      supabase.realtime.setAuth(storedAccessToken)
    }
  } catch (_) {
    // localStorage may be unavailable in non-browser test contexts.
  }

  supabase.auth.onAuthStateChange((event, session) => {
    if (session?.access_token) {
      supabase.realtime.setAuth(session.access_token)
      console.log('[Supabase] Realtime JWT updated for session', event)
    }
  })

  supabase.auth.getSession().then(({ data: { session } }) => {
    if (session?.access_token) {
      supabase.realtime.setAuth(session.access_token)
    }
  }).catch((err) => {
    console.warn('[Supabase] Initial Realtime JWT wiring failed:', err)
  })
}

export const isSupabaseConfigured = () => Boolean(supabase)
